import { connect } from 'react-redux';
import UnsubscriptionComponent from '../views/subscription/unsubscribeComponent';
import { incrementCount } from '../../redux/actions/authentication';

const mapStateToProps = (state) => ({
    count : state.authentication.count
});

const mapDispatchToProps = (dispatch) => ({
    incrementCount : () => dispatch(incrementCount())
});

const Unsubscription = connect(
  mapStateToProps,
  mapDispatchToProps
)(UnsubscriptionComponent);

export default Unsubscription;